import { Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useDataTable } from '@/shared/components/ui/data-table/context/data-table-context';
import { usePaginationQueryParams } from '@/shared/components/ui/pagination/hooks/use-pagination-query-params/use-pagination-query-params';
import { TagSkeleton } from '@/shared/components/ui/skeleton/skeleton.styled';

export const ItemCount = () => {
  const { t } = useTranslation();
  const { data } = useDataTable();
  const { page, pageSize } = usePaginationQueryParams();

  const calculateStart = () => {
    if (!data.items.length) {
      return 0;
    }

    return (page - 1) * pageSize + 1;
  };

  const calculateEnd = () => {
    if (!data.items.length) {
      return 0;
    }

    return (page - 1) * pageSize + data.items.length;
  };

  if (data.isLoading || data.isFetching) {
    return <TagSkeleton />;
  }

  return (
    <Typography variant="p7" marginLeft="0.5rem">
      {t('ui:results', {
        start: calculateStart(),
        end: calculateEnd(),
        count: data?.itemCount ?? 0,
      })}
    </Typography>
  );
};
